import { type UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import ToastService from '~/services/toast.service';

import { queryKeysParsingCase } from './queryKeys';
import { type ParsingCaseActionMutationResponse } from './types';

export function useParsingCaseActionMutationOptions<TVariables>(
  getSuccessMessage: () => string,
) {
  const queryClient = useQueryClient();

  return {
    onError() {
      return; // prevent error from bubbling up further unless overridden via mutation options
    },
    onSettled() {
      void queryClient.invalidateQueries({
        queryKey: [queryKeysParsingCase.base()],
      });
    },
    onSuccess() {
      ToastService.success(getSuccessMessage());
    },
  } satisfies UseMutationOptions<
    ParsingCaseActionMutationResponse,
    unknown,
    TVariables
  >;
}
